class ModalPage extends HTMLElement {
  constructor() {
    super();
    this.screen_body = document.querySelector('body');
    this.overlay = this.querySelector('.modal_page__overlay');
    this.body = this.querySelector('.modal_page__body');
    this.content = this.querySelector('.modal_page__content');
    this.closeButton = this.querySelector('.modal_page__close_btn');
    this.modal_btns = document.querySelectorAll('button[data-role="modal-trigger"]');
  }

  connectedCallback() {
    this.overlay.addEventListener('click', () => {
      this.close();
    });

    this.closeButton.addEventListener('click', () => {
      this.close();
    });

    this.modal_btns.forEach(btn => {
      btn.addEventListener('click', async () => {
        await this.open(btn.dataset.link);
      });
    });
  }

  close() {
    this.classList.add('hidden');
    this.screen_body.style.overflow = 'auto';
  }

  async open(url) {
    if (url === '#') return;
    this.screen_body.style.overflow = 'hidden';
    try {
      const page = await fetch(url);
      const pageData = await page.text();
      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(pageData, 'text/html');
      const content = parsedHTML.querySelector('main').innerHTML;
      this.content.innerHTML = content;
      this.classList.remove('hidden');
    } catch (error) {
      console.error('Error fetching page:', error);
    }
  }
  
}
customElements.define('modal-page', ModalPage);